import { getText } from '../../../shared/text';

const { settings } = getText('EN');

export const settingsData = [
  {
    id: 'globalSurveyLimit',
    name: settings.surveylimit.layout.heading,
    description: 'settings.global_survey_limit.description',
    icon: '/settings/global-survey-limit.svg',
    href: '/limit',
  },
  {
    id: 'translationSettings',
    name: settings.translationsettings.layout.heading,
    description: 'settings.translation_settings.description',
    icon: '/settings/translation-settings.svg',
    href: '/translation-settings',
  },
  {
    id: 'userManagement',
    name: settings.user.layout.heading,
    description: 'settings.user_management.description',
    icon: '/settings/user-management.svg',
    href: '/user',
  },
  {
    id: 'savedTemplates',
    name: settings.savedtemplates.layout.heading,
    description: 'settings.saved_templates.description',
    icon: '/settings/saved-templates.svg',
    href: '/templates',
  },
  {
    id: 'designThemes',
    name: settings.designThemes.layout.heading,
    description: 'settings.design_themes.layout.description',
    icon: '/settings/design-themes.svg',
    href: '/design-themes',
  },
  // {
  //   id: 'blocklist',
  //   name: settings.blocklist.layout.heading,
  //   href: '/blocklist',
  // },
  {
    id: 'customFields',
    name: settings.customfields.layout.heading,
    description: 'settings.custom_fields.description',
    icon: '/settings/contact-fields.svg',
    href: '/customfields',
  },
  {
    id: 'blockedSentimentTopic',
    name: settings.blockedSentimentTopic.layout.heading,
    description: 'settings.blocked_sentiment_topic.description',
    icon: '/settings/blocked-sentiments.svg',
    href: '/blocked-sentiment-topic',
  },
  {
    id: 'tags',
    name: settings.tags.layout.heading,
    description: 'settings.tags.description',
    icon: '/settings/tags.svg',
    href: '/tags',
  },
  {
    id: 'dkimSettings',
    name: settings.dkimsettings.layout.heading,
    description: 'settings.dkim_settings.description',
    icon: '/settings/dkim-settings.svg',
    href: '/dkim',
  },
  {
    id: 'customDomainMapping',
    name: settings.customdomainmapping.layout.heading,
    description: 'settings.custom_domain.description',
    icon: '/settings/custom-domain.svg',
    href: '/custom-domain',
  },
  // {
  //   id: 'integrations',
  //   name: settings.integrations.layout.heading,
  //   href: '/integrations'
  // },
  {
    id: 'accountInfo',
    name: settings.accountinfo.layout.heading,
    description: 'settings.account_info.description',
    icon: '/settings/account-info.svg',
    href: '/account',
  },
];
